import { ACCEPTED_IMAGE_FORMAT } from 'src/constants/upload.constant';

export const ACCEPTED_LOGO_FILE_FORMATS = [...Object.keys(ACCEPTED_IMAGE_FORMAT), 'image/svg+xml'].join(',');
